import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'

import Forms from '@/store/modules/forms'
import Filters from '@/store/modules/filters'
import { HeaderGral } from '@/store/modules/config'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    urls: null,

    objects: [],
    objectsTwo: [],
    object: {},
    logout: {},
    dialogMain: {
      dialog: false,
      type: '',
      form: '',
      withWindows: 500,
      title: '',
      body: {}
    },
    alertMain: {
      alert: false,
      type: '',
      withWindows: 500,
      title: '',
      body: {},
      confirmBtnText: '',
      cancelBtnText: ''
    },
    sendDataView: {},
    objectPagination: {},
    options: {},
    model: {},
    objectFamily: {},
    reload: {},
    loading: false,
    btnLoading: false,
    dialogReport: {
      show: false,
      tittle: '',
      urloption: '',
      type: ''
    }
  },
  getters: {
    get_urls (state) { return state.urls },
    get_dialogMain (state) { return state.dialogMain },
    get_alertMain (state) { return state.alertMain },
    get_sendDataView (state) { return state.sendDataView },

    get_objects (state) { return state.objects },
    get_objectTwo (state) { return state.objectsTwo },
    get_object (state) { return state.object },
    get_object_logout (state) { return state.logout },

    get_options (state) { return state.options },
    get_objectFamily (state) { return state.objectFamily },
    get_model (state) { return state.model },
    get_objectPagination (state) { return state.objectPagination },
    get_reload (state) { return state.reload },
    get_loading (state) { return state.loading },
    get_dialogReport (state) { return state.dialogReport },
    get_shoeBtnLoading (state) { return state.btnLoading }
  },
  mutations: {
    // *==========*==========* Variables de Sesion *==========*==========* \\
    // *==========*==========*==========*==========*==========*==========* \\
    GET_URLS_SERVER (state, urls) {
      state.urls = {}
      state.urls = urls
    },
    SHOW_DIALOG_MAIN (state, data) {
      state.dialogMain.dialog = true
      state.dialogMain.type = data.type
      state.dialogMain.form = (data.form) ? data.form : 'form'
      state.dialogMain.withWindows = (data.with) ? data.with : '50%'
      state.dialogMain.title = (data.title) ? data.title : 'Sin Titulo'
      state.dialogMain.body = data.body
    },
    HIDDE_DIALOG_MAIN (state) {
      state.dialogMain.dialog = false
      state.dialogMain.type = ''
      state.dialogMain.form = 'form'
      state.dialogMain.withWindows = '50%'
      state.dialogMain.title = ''
      state.dialogMain.body = {}
    },

    SHOW_LOADING_MAIN (state, data) {
      state.btnLoading = true
    },
    HIDDE_LOADING_MAIN (state, data) {
      state.btnLoading = false
    },

    SEND_DATA_VIEW (state, data) {
      state.sendDataView = data
    },
    SHOW_DIALOG_ALERT_MAIN (state, data) {
      state.alertMain.alert = true
      state.alertMain.type = data.type
      state.alertMain.withWindows = (data.with) ? data.with : '50%'
      state.alertMain.title = (data.title) ? data.title : 'Sin Titulo'
      state.alertMain.body = data.body
      state.alertMain.confirmBtnText = data.confirmButtonText
      state.alertMain.cancelBtnText = data.cancelButtonText
    },
    HIDDE_DIALOG_ALERT_MAIN (state) {
      state.alertMain.alert = false
      state.alertMain.type = ''
      state.alertMain.withWindows = '50%'
      state.alertMain.title = ''
      state.alertMain.body = {}
      state.alertMain.confirmBtnText = ''
      state.alertMain.cancelBtnText = ''
    },
    // *==========*==========*==========*==========*==========*==========* \\
    DATA_SERVICES (state, data) {
      state.object = {}
      state.object = data
    },
    OPTION_NEXT_ACTION (state, options) {
      state.options = {}
      state.options = options
    },
    OPTION_FORM_ACTION (state, options) {
      state.options_form = {}
      state.options_form = options
    },
    GET_OBJECTS_FAMILY (state, data) {
      state.objectFamily = {}
      state.objectFamily = data
    },
    EXECUTE_ACTION (state, action) {
      state.model = {}
      state.model = action
    },
    // *==========*==========*==========*==========*==========*==========* \\
    GET_LIST_OBJECTS (state, data) {
      state.objects = []
      state.objects.push(...data)
    },
    GET_LIST_OBJECTS_TWO (state, data) {
      state.objectsTwo = []
      state.objectsTwo.push(...data)
    },
    SET_DATA_OBJECT (state, data) {
      let findobject = -1
      state.objects.map((el, i) => { if (el.id === data.id) findobject = i })
      if (findobject !== -1) Object.assign(state.objects[findobject], data)
      else state.objects.push(data)
    },
    GET_DATA_SERVER_TWO (state, data) {
      state.objectTwo = {}
      state.objectTwo = data
    },
    DELETE_DATA_OBJECT (state, data) {
      state.objects = state.objects.filter(el => el.id !== parseInt(data.id))
    },
    POST_DATA_OBJECT (state, object) {
      state.object = {}
      state.object = object
    },
    POST_LIST_OBJECTS_PAGINATION (state, object) {
      state.objectPagination = {}
      state.objectPagination = object
    },
    POST_DATA_OBJECT_LOGOUT (state, object) {
      state.logout = {}
      state.logout = object
    },
    CLEAR_OBJECT (state) {
      state.object = {}
    },
    CLEAR_OBJECTS (state) {
      state.objects = []
    },
    CLEAR_OBJECTS_OPTIONS (state) {
      state.options = {}
    },
    CLEAR_OBJECTS_MODEL (state) {
      state.model = {}
    },
    SET_LOADING_STATUS (state, data) {
      state.loading = data
    },
    SET_DELETE_DATA (state, data) {
      const rows = state.objects.filter(el => el.id !== parseInt(data.id))
      state.objects = rows
    },
    SET_DATA (state, data) {
      let findobject = -1
      state.objects.map((el, i) => { if (el.id === parseInt(data.id)) findobject = i })

      if (findobject !== -1) Object.assign(state.objects[findobject], data)
      else state.objects.push(data)
    },
    SET_DATA_OBJECT_FIND (state, data) {
      state.objectFind = data
    },
    RELOAD_DATA_OBJECT (state, data) {
      state.reload = data
    },
    SHOW_DIALOG_REPORT (state, data) {
      state.dialogReport.show = true
      state.dialogReport.tittle = data.tittle
      state.dialogReport.urloption = data.urloption
      state.dialogReport.type = data.type
    }
  },
  actions: {
    getUrlServices ({ commit }) {
      axios.post('/app/rutas').then(response => {
        commit('GET_URLS_SERVER', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    PUTDisableEnableObjectService ({ commit }, action) {
      const header = HeaderGral()
      let url = action.url
      if (action.params) {
        url = action.url.replace(action.replace, action.params)
      }
      axios.put(`${url}`, action.data, header).then((response) => {
        commit('SET_DATA', response.data)
      }).catch((error) => {
        if (error == null) {
          Vue.swal({ type: 'error', title: 'Ooops!', text: 'Problemas con el servidor, contactar al sistemas !!' })
        }
      })
    },
    // *==========*==========*   Actions Get´s   *==========*==========* \\
    GETObjectService ({ commit }, action) {
      const header = HeaderGral()
      let ruta = action.url
      if (action.params) { ruta = action.url.replace(action.replace, action.params) }

      axios.get(`${ruta}`, header).then((response) => {
        commit('DATA_SERVICES', response.data)
      })
        .catch((error) => {
          if (error == null) Vue.swal({ type: 'error', title: 'Ooops!', text: 'Problemas con el servidor, contactar al sistemas !!' })
        })
    },
    GETObjects ({ commit }, action) {
      let ruta = ''
      const params = (action.params) ? action.params : ''
      const header = HeaderGral()
      ruta = action.url
      if (action.replace_data) ruta.replace(action.replace, action.replace_data)
      axios.get(`${ruta}${params}`, header).then((response) => {
        commit('GET_LIST_OBJECTS', response.data)
      })
        .catch((error) => {
          if (error == null) Vue.swal({ type: 'error', title: 'Ooops!', text: 'Problemas con el servidor, contactar al sistemas !!' })
        })
    },
    GETObjectTwo ({ commit }, action) {
      let ruta = ''
      const params = (action.params) ? action.params : ''
      const header = HeaderGral()
      ruta = action.url
      if (action.replace_data) ruta.replace(action.replace, action.replace_data)
      axios.get(`${ruta}${params}`, header).then((response) => {
        commit('GET_LIST_OBJECTS_TWO', response.data)
      })
        .catch((error) => {
          if (error == null) Vue.swal({ type: 'error', title: 'Ooops!', text: 'Problemas con el servidor, contactar al sistemas !!' })
        })
    },
    // *==========*==========*==========*==========*==========*==========* \\

    // *==========*==========*   Actions Deleted´s   *==========*==========* \\
    DELETEObject ({ commit }, action) {
      const header = HeaderGral()
      let params = ''
      let url = action.url
      if (action.params) {
        url = action.url.replace(action.replace, '')
        params = action.params
      }
      axios.delete(`${url}${params}`, header).then(response => {
        commit('SET_DELETE_DATA', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    DELETEObjectService ({ commit }, action) {
      const header = HeaderGral()
      let params = ''
      let url = action.url
      if (action.params) {
        url = action.url.replace(action.replace, '')
        params = action.params
      }
      axios.delete(`${url}${params}`, header).then(response => {
        commit('SET_DELETE_DATA', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    // *==========*==========*==========*==========*==========*==========* \\

    // *==========*==========*   Actions Post´s   *==========*==========* \\

    POSTObjectsService ({ commit }, action) {
      const header = HeaderGral()
      axios.post(`${action.url}`, action.data, header).then((response) => {
        commit('DATA_SERVICES', response.data)
      })
        .catch((error) => {
          if (error == null) Vue.swal({ type: 'error', title: 'Ooops!', text: 'Problemas con el servidor, contactar al sistemas !!' })
        })
    },
    urlGetServiceActionTwo ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      let params = ''
      if (action.params) {
        action.url = action.url.replace(action.replace, '')
        params = action.params
      }
      axios.get(`${action.url}${params}`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('GET_DATA_SERVER_TWO', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    POSTObject ({ commit }, action) {
      const header = HeaderGral()
      axios.post(`${action.url}`, action.data, header).then((response) => {
        commit('POST_DATA_OBJECT', response.data)
      })
        .catch((error) => {
          if (error == null) Vue.swal({ type: 'error', title: 'Ooops!', text: 'Problemas con el servidor, contactar al sistemas !!' })
        })
    },
    POSTPagination ({ commit }, action) {
      const header = HeaderGral()
      axios.post(`${action.url}`, action.data, header).then(response => {
        commit('POST_LIST_OBJECTS_PAGINATION', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    POSTObjectLogout ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      axios.post(`${action.url}`, action.data, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('POST_DATA_OBJECT_LOGOUT', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    postExecuteAction ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      axios.post(`${action.url}`, action.data, { headers: { Authorization: `Bearer ${token}` } })
        .then(response => {
          commit('EXECUTE_ACTION', response.data)
        })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    // *==========*==========*==========*==========*==========*==========* \\
    GetObjectFamilia ({ commit }, action) {
      const header = HeaderGral()
      let params = ''
      if (action.params) {
        action.url = action.url.replace(action.replace, '')
        params = action.params
      }
      axios.get(`${action.url}${params}`, header).then(response => {
        commit('GET_OBJECTS_FAMILY', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    // *==========*==========*  Main Process Act   *==========*==========* \\
    GETOptionService ({ commit }, action) {
      const header = HeaderGral()
      if (action.params) {
        action.url = action.url.replace(action.replace, action.params)
      }
      axios.get(`${action.url}`, header)
        .then((response) => {
          commit('OPTION_NEXT_ACTION', response.data)
        })
        .catch((error) => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    GETOptionFormService ({ commit }, action) {
      const header = HeaderGral()
      if (action.params) {
        action.url = action.url.replace('[/{status_id}]', action.params)
      }
      axios.get(`${action.url.uri}`, header)
        .then((response) => {
          commit('OPTION_FORM_ACTION', response.data)
        })
        .catch((error) => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    POSTExecuteService ({ commit }, action) {
      const header = HeaderGral()
      axios.post(`${action.url}`, action.data, header)
        .then((response) => {
          commit('EXECUTE_ACTION', response.data)
        })
        .catch((error) => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    PUTExecuteService ({ commit }, action) {
      let ruta = ''
      const header = HeaderGral()
      const params = (action.params) ? action.params : ''
      ruta = action.url
      if (action.replace_data) ruta = ruta.replace(action.replace, action.replace_data)

      axios.put(`${ruta}${params}`, action.data, header)
        .then((response) => {
          commit('EXECUTE_ACTION', response.data)
        })
        .catch((error) => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    DELETEExecuteService ({ commit }, action) {
      let ruta = ''
      const header = HeaderGral()
      const params = (action.params) ? action.params : ''
      ruta = action.url
      if (action.replace_data) ruta = ruta.replace(action.replace, action.replace_data)

      axios.delete(`${ruta}${params}`, header).then(response => {
        commit('EXECUTE_ACTION', response.data)
      }).catch(error => {
        if (error == null) {
          Vue.swal({
            type: 'error',
            title: 'Ooops!',
            text: 'Problemas con el servidor, contactar al sistemas !!'
          })
        }
      })
    },
    POSTExecuteMultipart ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      const boundary = `; boundary=${action.data._boundary}`
      axios.post(`${action.url}`, action.data, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data' + boundary
        }
      }).then(response => {
        commit('EXECUTE_ACTION', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },

    GETExportPdftSerice ({ commit }, action) {
      const header = HeaderGral()
      let url = action.url
      let addicional = ''

      if (action.params) url = action.url.replace(action.replace, action.params)
      if (action.addicional) addicional = action.addicional

      axios.get(`${url}${addicional}`, header).then(response => {
        const file = response.data
        const linkSource = `data:application/pdf;base64,${file.pdf}`
        const downloadLink = document.createElement('a')
        downloadLink.href = linkSource
        downloadLink.download = file.nombre
        downloadLink.click()

        // let pdfWindow = window.open('')
        // pdfWindow-.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(file.pdf) + "'></iframe>")
      }).catch(error => {
        if (error == null) {
          Vue.swal({
            type: 'error',
            title: 'Ooops!',
            text: 'Problemas con el servidor, contactar al sistemas !!'
          })
        }
      })
    },

    async urlGetData ({ commit }, url) {
      const token = Vue.$cookies.get('token')
      const data = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        return response.data
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
      return data
    },
    async getUrExportDataServerAction ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      let params = ''
      let url = action.url
      if (action.params) {
        url = action.url.uri.replace(action.replace, '')
        params = action.params
      }
      axios.defaults.headers = { Authorization: `Bearer ${token}` }
      await axios.get(`${url}${params}`, { responseType: 'blob' }).then(response => {
        const typeValidos = ['application/zip']
        if (typeValidos.includes(response.data.type)) {
          const blob = new Blob([response.data], { type: response.data.type })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `Documentos-${action.data.folio}.zip`
          link.click()
          URL.revokeObjectURL(link.href)
        } else {
          Vue.swal({
            type: 'error',
            title: 'Ooops!',
            text: 'Error: El archivo viene dañado'
          })
        }
      }).catch(error => {
        if (error == null) {
          Vue.swal({
            type: 'error',
            title: 'Ooops!',
            text: 'Problemas con el servidor, contactar al sistemas !!'
          })
        }
      })
    }

  },
  modules: {
    Forms,
    Filters
  }
})
